import React from 'react';
import { motion } from 'framer-motion';
export function HeroSection() {
  return <section id="home" className="relative h-[90vh] min-h-[600px] flex items-center justify-center overflow-hidden" data-id="element-167">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0" data-id="element-168">
        <img src="https://cdn.magicpatterns.com/uploads/jdmU9bRHXz3gSRBZfRVZKU/imgi_5_WhatsApp_Image_2023-03-18_at_12_54_02_(2).jpg" alt="MT2RL Laboratory" className="w-full h-full object-cover" data-id="element-169" />
        <div className="absolute inset-0 bg-gradient-to-r from-[#4A0000]/90 to-[#1A0000]/70 mix-blend-multiply" data-id="element-170"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-171">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} data-id="element-172">
          <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold text-white mb-6 leading-tight font-serif drop-shadow-lg" data-id="element-173">
            Multiscale Thermal Transport <br className="hidden md:block" data-id="element-174" />
            <span className="text-yellow-500" data-id="element-175">Research Laboratory</span>
          </h1>
        </motion.div>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.2,
        ease: 'easeOut'
      }} className="mt-4 max-w-3xl mx-auto text-xl sm:text-2xl text-gray-200 font-light mb-10" data-id="element-176">
          Investigating fluid flow and heat transfer across multiple length
          scales at IIT Madras
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.4,
        ease: 'easeOut'
      }} className="flex flex-col sm:flex-row gap-4 justify-center" data-id="element-177">
          <a href="#research" className="px-8 py-4 bg-[#800000] hover:bg-[#6B0F1A] text-white rounded-md font-medium text-lg transition-colors shadow-lg" data-id="element-178">
            Explore Research
          </a>
          <a href="#people" className="px-8 py-4 bg-white/10 hover:bg-white/20 text-white border border-white/30 backdrop-blur-sm rounded-md font-medium text-lg transition-all" data-id="element-179">
            Meet Our Team
          </a>
        </motion.div>
      </div>
    </section>;
}